import {
  CapacityGranularity,
  capacityGranularity,
} from "./capacityGranularity";
import { CapacitySort } from "./capacitySort";
import { Filter } from "./filter";

type RetrieveWorkloadRequest = {
  from: string;
  to: string;
  granularity: CapacityGranularity;
  page: number;
  size: number;
  filter?: Filter;
  sort?: CapacitySort;
};

const retrieveWorkloadRequest: RetrieveWorkloadRequest = {
  from: "",
  to: "",
  granularity: capacityGranularity,
  page: 0,
  size: 20,
};

export type { RetrieveWorkloadRequest };

export { retrieveWorkloadRequest };
